<template>
  <span>
    <!--MENU PRINCIPAL-->
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      ref="drawer1ref"
      class="fs-drawer"
      v-model="drawer"
      width="242px"
      app
    >
      <v-row no-gutters>
        <v-avatar width="30" height="30" class="ml-n1" style="margin-top: 2px; margin-bottom: -3px">
          <img :src="require('@/assets/fk-logo.png')" alt="John">
        </v-avatar>
        <div style="font-weight: 300; font-size: 13px; margin-top: 8px" class="ml-1">
          <b style="font-weight: 700">FORTKOL - </b>
          Fitas Adesivas
        </div>
      </v-row>
      <v-list style="margin-top: 7px" dense>
        <v-list-item
          :class="JSON.stringify(item) === JSON.stringify(itemMenu) ? 'fs-menu-item-selected' : ''"
          @click="abrirItemMenu1(item)"
          v-for="item in items"
          :key="item.descricao"
          link>
          <v-list-item-icon>
            <v-icon class="fs-icons-drawer1">{{ item.icone }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ml-n6">
            <v-list-item-title>{{ item.descricao }}</v-list-item-title>
            <v-icon v-if="item.telas.length > 1 || (item.titulo !== item.telas[0].descricao)" class="fs-menu-icon-expand">
              mdi-chevron-right
            </v-icon>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!--MENU SECUNDARIO-->
    <transition name="fade">
      <v-navigation-drawer
        v-if="itemMenu.telas && (itemMenu.titulo !== itemMenu.telas[0].descricao)"
        :class="drawer2 ? 'fs-drawer2' : 'fs-drawer2-oculto'"
        :clipped="$vuetify.breakpoint.lgAndUp"
        ref="drawer2ref"
        v-model="drawer2"
        width="199px"
        fixed
      >
        <span id="span-drawer2">
          <span class="ml-4">
            <v-icon class="fs-icon-title-drawer2">{{ itemMenu.icone }}</v-icon>
            <span class="ml-2" style="font-size: 13px;">{{ itemMenu.descricao }}</span>
            <v-btn class="fs-icon-close-drawer2 mr-n1" @click="fecharDrawer2()" icon>
              <v-icon color="primary">
                mdi-close-circle
              </v-icon>
            </v-btn>
          </span>
          <v-divider class="mt-3 mb-n2"></v-divider>
          <v-list dense>
            <v-list-item
              :class="item === subItemMenu ? 'fs-menu-item-selected2' : 'fs-item-drawer2'"
              @click="abrirItemMenu2(item)"
              v-for="item in itemMenu.telas"
              :key="item.descricao"
              link
            >
              <v-list-item-icon>
                <v-icon class="fs-icons-drawer2">{{ item.icone }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="ml-n7">
                <v-list-item-title style="color: black !important;">{{ item.descricao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </span>
      </v-navigation-drawer>
    </transition>
  </span>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      drawer: !this.$vuetify.breakpoint.mdAndDown,
      drawer2: !this.$vuetify.breakpoint.mdAndDown,
      items: []
    }
  },
  watch: {
    drawer: function (novo, antigo) {
      if (!this.drawer && this.$vuetify.breakpoint.mdAndDown) this.setStatusMenu(false)
      if (this.drawer2 && this.itemMenu.telas) {
        this.drawer = true
        this.$refs.drawer1ref.isActive = true
      }
    },
    statusMenu: function () {
      if (this.statusMenu) {
        this.drawer = true
        this.drawer2 = true
      } else {
        this.drawer = false
        this.drawer2 = false
      }
    }
  },
  computed: {
    ...mapState({
      statusMenu: state => state.menu.statusMenu,
      itemMenu: state => state.menu.itemMenu,
      subItemMenu: state => state.menu.subItemMenu
    })
  },
  async mounted () {
    if (this.$vuetify.breakpoint.mdAndDown) this.setStatusMenu(false)
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.items = userInfo.acesso.modulos
  },
  methods: {
    ...mapMutations({
      setStatusMenu: 'menu/setStatusMenu',
      setItemMenu: 'menu/setItemMenu',
      setSubItemMenu: 'menu/setSubItemMenu',
      setSnackbar: 'global/setSnackbar'
    }),
    abrirItemMenu1 (item) {
      this.setItemMenu(item)
      if (item.telas.length > 1) {
        this.drawer2 = true
      } else if (item.telas.length === 1) {
        if (item.telas[0].descricao === item.titulo) {
          this.drawer2 = false
          this.setSubItemMenu({})
          this.redirecionar(item.telas[0].web_url)
        } else {
          this.drawer2 = true
          this.setSubItemMenu({})
        }
      } else if (!item.telas.length) {
        this.drawer2 = false
        this.setSubItemMenu({})
        this.setSnackbar({ msg: 'Não existem telas vinculadas a esse módulo!', color: 'error' })
      } else {
        this.drawer2 = false
        this.setSubItemMenu({})
        // this.redirecionar(item.web_url)
      }
      // this.setItemMenu(item)
      // if (item.telas.length > 1) {
      //   this.drawer2 = true
      // } else if (item.telas.length === 1) {
      //   this.drawer2 = false
      //   this.setSubItemMenu({})
      //   this.redirecionar(item.telas[0].web_url)
      // } else if (!item.telas.length) {
      //   this.drawer2 = false
      //   this.setSubItemMenu({})
      //   this.setSnackbar({ msg: 'Não existem telas vinculadas a esse módulo!', color: 'error' })
      // } else {
      //   this.drawer2 = false
      //   this.setSubItemMenu({})
      //   this.redirecionar(item.web_url)
      // }
    },
    abrirItemMenu2 (item) {
      this.setSubItemMenu(item)
      this.redirecionar(item.web_url)
    },
    redirecionar (path) {
      if (this.$router.currentRoute.path !== path) this.$router.push(path)
    },
    fecharDrawer () {
      this.drawer2 = false
      this.drawer = !this.drawer
    },
    fecharDrawer2 () {
      if (this.drawer2) this.drawer2 = false
    }
  }
}
</script>

<style scoped>
.fs-menu-icon-expand {
  color: white !important;
  position: fixed !important;
  right: 10px !important;
}
.fs-icon-close-drawer2 {
  margin-top: -3px;
  position: fixed !important;
  right: 5px !important;
}
.fs-drawer {
  padding-top: 14px;
  background-color: #0A0D1E !important;
  color: white !important;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}
.fs-drawer2, .fs-drawer2-oculto {
  transition: .3s;
  padding-top: 16px !important;
  margin-top: 50px;
  margin-left: 43px !important;
  background-color: #F0F0F0 !important;
}
.fs-drawer2-oculto {
  transition: .5s;
  opacity: 0.15;
  margin-left: 0px !important;
}
@media only screen and (max-width: 1263px) {
  .fs-drawer2, .fs-drawer2-oculto {
    margin-top: 0px !important;
  }
}
.fs-item-drawer2:hover {
  border-left: 4px solid #2A2F50 !important;
}
.fs-menu-item-selected {
  background-color: rgba(179, 179, 179, 0.205);
  border-left: 3px solid white !important;
  color: white;
}
.fs-menu-item-selected2 {
  background-color: rgba(179, 179, 179, 0.295);
  border-left: 4px solid #2A2F50 !important;
}
.fs-icons-drawer1 {
  color: white !important;
}
.fs-icons-drawer2 {
  color: #2A2F50 !important;
}
.fs-icon-title-drawer2 {
  margin-left: -8px;
  border-radius: 50%;
  padding: 6px;
  color: white !important;
  background-color: #2A2F50;
}
.v-list {
  background-color: #ffffff00 !important;
}
.v-list-item__title {
  letter-spacing: .3px;
  font-weight: 300 !important;
  font-size: 12px !important;
  color: white !important;
}
.v-list-item {
  padding-left: 12px;
}
.v-list-item:hover {
  transition: .4s;
  border-left: 3px solid rgb(255, 255, 255);
  color: white;
  background-color: rgba(179, 179, 179, 0.205);
}
.v-list-item:not( :hover ){
  border-left: 0px solid rgba(255, 255, 255, 0);
  transition: .3s;
}
.fade-enter,
.fade-leave-to {
  visibility: hidden;
  height: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
</style>
